import React from 'react';
import { DatePicker } from 'antd';
import './datePicker.scss';

interface DatePickerComponentProps {
    value?: string;
    className?: string;
    onChangeEvent?: (date: any, dateString: string | string[]) => void;
    style?: React.CSSProperties;
    format?: string;
    showTime?: {
        format?: string;
    }
    disabledDate?: (current: any) => boolean;
    disabledTime?: (date: any) => any;
}

const DatePickerComponent = ({
    value = '',
    className = '',
    onChangeEvent = () => {},
    style = {},
    format = 'DD-MMM-YYYY',
    showTime,
    disabledDate,
    disabledTime,
    ...otherProps
}: DatePickerComponentProps) => {
    return (
        <>
            <DatePicker
                className={className}
                value={value}
                onChange={onChangeEvent}
                style={style}
                format={format}
                showTime={showTime}
                disabledDate={disabledDate}
                disabledTime={disabledTime}
                { ...otherProps }
            />
        </>
    );
};

export default DatePickerComponent;
